export default "__VITE_ASSET__eRmB3qQP__"